<template>
  <div class="ClientList">
    <div class="row ClientList_Item">
      <div class="col-12 MoreDivInLine_16" v-for="(item, index) in temp_Value" :key="index">
        <div class="MoreDivInLine_Row ClientList_Main">
          <div class="MoreDivInLine_16 col-12">
            <div class="MoreDivInLine_Row">
              <textbox :ControlId="'clientName_' + index" type="text" v-model="item.clientName"
                :title="$t('lbl_EMPBE_CompanyInfo_ClientList_CompanyClientName')">
              </textbox>
              <CompanyFieldApprovalResults
                usage-type="ClientName"
                :usage-id="resolveClientApprovalUsageId(item, index)"
              />
            </div>
            <div class="MoreDivInLine_Row">
              <selection :ControlId="'countryId_' + index"
                :title="$t('lbl_EMPBE_CompanyInfo_ClientList_CountryOrRegion')" label="Name"
                :name="'countryId_' + index" v-model="item.countryId" :options="temp_OptionCountrys" :multiple="false"
                :preselect-first="true">
              </selection>
            </div>
          </div>
          <div class="col-12 UploadTitle" v-if="APlusBooth">
            {{ $t("lbl_EMPBE_CompanyInfo_ClentUploadTips") }}
          </div>
          <div class="col-12" v-if="APlusBooth">
            <mediaUploader
              :MediaArray="clientImageList[index]"
              :limit="1"
              :maxSize="5"
              aspectRatioStr="1:1"
              galleryItemStyle="height: 80px; width: 80px;"
              mediaType="image"
              :key="'ClientImageUploader_'+index"
              :ref="'ClientImageUploader_'+index"
              fileUsageType="CompanyClient_Logo"
              filePathEndpoint="Image"
              @update="(cmd, files) => handlerUploaderUpdateData(cmd, files, index)"
            />
          </div>
        </div>
        <div class="Del">
          <a href="javascript:;"><img :src="cdnURL + 'DelSale_Enquiry.svg'" @click="DelClientList(index)" /></a>
        </div>
      </div>

    </div>
    <b-button v-if="temp_Value.length < nums" class="btn btn-outline-primary p-l-15 d-flex align-items-center AddButton"
      variant="outline-primary" @click="AddClientList" v-bind:t_label="'EMPBE_Other_contract_info_add'">
      <feather type="plus-circle"> </feather>
      &nbsp; {{ $t("lbl_EMPBE_CompanyInfo_ClientList_AddButtom") }}
    </b-button>

  </div>
</template>
<script>
import mediaUploader from "../../../components/form/upload/imgUploader/mediaUploader.vue";
import CompanyFieldApprovalResults from '../CompanyFieldApprovalResults.vue';
import {
  getInitImageDataObj
} from '@/_helpers/media-uploader-utils.js';
import {
  getDeleteOSSUrlOnDbCommand
} from '@/_helpers/utility.js';

export default {
  components: {
    mediaUploader,
    CompanyFieldApprovalResults,
  },
  inject: {
    permissionData: { default: null },
    companyApprovalHost: { default: null },
  },
  props: ["value", 'nums', "CountryOptions", "supplierId"],
  data() {
    return {
      temp_Value: this.value,
      clientImageList: [],
      temp_OptionCountrys: this.CountryOptions,
      cdnURL: "https://cdn.adsalecdn.com/EMP/Backend/svg/CompanyInfo/",
      Init_newClient:
      {
        empCompanyId: this.supplierId,
        orderId: null,
        clientName: "",
        countryId: null,
        isPendingInsert: true,
        updateFileCommands: [],
        pendingFiles: [],
      }
    }
  },
  watch: {
    value(newVal) {
      this.temp_Value = newVal;

      this.$nextTick(() => {
        this.clientImageList = [];
        newVal.forEach((item) => {
          this.clientImageList.push(
            item.fileId && item.fileName
                ? [
                      getInitImageDataObj(item, {
                          id: item.fileId,
                          cdnLink: item.fileName,
                          orderId: item.orderId,
                          usageType: "CompanyClient_Logo",
                      }),
                  ]
                : []
          );
        });
      });
    },
    temp_Value: {
      handler(newVal) {
        this.$emit("input", newVal);
      }, deep: true
    },
    CountryOptions: {
      handler() {
        this.temp_OptionCountrys = this.CountryOptions;
      }, deep: true
    },
  },
  computed: {
    APlusBooth() {
      if (this.permissionData) {
        return ["A+"].includes(this.permissionData["Type"]);
      } else {
        return false;
      }
    },
    /** ClientName 审批行 → 列表下标；优先 RID，对不上再按顺序兜底 */
    clientApprovalUsageIdByIndex() {
      const host = this.companyApprovalHost;
      const clients = this.temp_Value || [];
      const map = {};
      if (!host || typeof host.getCompanyApprovalResultsByUsageType !== 'function') {
        return map;
      }
      // 建立对审批结果的依赖，详情异步加载后能重算
      const _approvalRows = host.approvalContentResults;
      void _approvalRows;

      const rows = (host.getCompanyApprovalResultsByUsageType(['ClientName']) || []).slice();
      if (!rows.length || !clients.length) return map;

      const usedKeys = new Set();
      const resultKey = (row) => {
        const id = row?.approvalRequestResultId ?? row?.ApprovalRequestResultId;
        if (id != null && id !== '') return `id_${id}`;
        return `u_${row?.usageId ?? row?.UsageId ?? ''}`;
      };

      clients.forEach((client, index) => {
        const rid = this.clientRowId(client);
        if (rid == null) return;
        const hit = rows.find((row) => {
          const usageId = row?.usageId ?? row?.UsageId;
          return String(usageId ?? '').trim() === String(rid).trim();
        });
        if (!hit) return;
        map[index] = hit.usageId ?? hit.UsageId;
        usedKeys.add(resultKey(hit));
      });

      const unmatchedRows = rows.filter((row) => !usedKeys.has(resultKey(row)));
      const unmatchedIndexes = clients
        .map((_, index) => index)
        .filter((index) => map[index] == null);

      unmatchedIndexes.forEach((clientIndex, i) => {
        const row = unmatchedRows[i];
        if (!row) return;
        const usageId = row.usageId ?? row.UsageId;
        if (usageId == null || String(usageId).trim() === '') return;
        map[clientIndex] = usageId;
      });

      return map;
    },
  },
  methods: {
    clientRowId(item) {
      if (!item) return null;
      const id = item.rid ?? item.RID ?? item.Rid ?? item.rID;
      return id == null || id === '' ? null : id;
    },
    resolveClientApprovalUsageId(item, index) {
      const mapped = this.clientApprovalUsageIdByIndex[index];
      if (mapped != null && String(mapped).trim() !== '') return mapped;
      return this.clientRowId(item);
    },
    AddClientList() {
      var newClient = JSON.parse(JSON.stringify(this.Init_newClient));
      const currLength = this.temp_Value.length;
      newClient.orderId = currLength + 1;
      this.temp_Value.push(newClient);
      this.clientImageList.push([]);
    },
    DelClientList(index) {
      const isPendingInsert = this.temp_Value[index].isPendingInsert;
      if (!isPendingInsert) {
        const deleteItem = this.clientImageList[index]?.length > 0 ? this.clientImageList[index][0] : null;
        const deleteCommand = getDeleteOSSUrlOnDbCommand(deleteItem?.id ?? 0, deleteItem?.cdnLink ?? "", deleteItem?.orderId ?? 0, deleteItem?.usageType ?? "");
        this.$emit("removeCertImage", deleteCommand);
      }
      this.clientImageList.splice(index,1);
      this.temp_Value.splice(index, 1);
    },
    handlerUploaderUpdateData(commands, pendingFiles, index) {
      this.$set(this.temp_Value[index], "updateFileCommands", commands);
      this.$set(this.temp_Value[index], "pendingFiles", pendingFiles);
      // 图片变更需标 dirty，确保切 Tab 自动保存
      this.$store.state.dirty = true;
    },
  }

}
</script>
<style lang="scss" scoped>
.ClientList_Item {
  gap: 8px;
}

.Del {
  margin-top: 7px;
}

.theme-form .form-group {
  margin-bottom: 8px !important;
}

.UploadTitle {
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 400;
  line-height: 18.20px;
  word-wrap: break-word
}

.ClientList_Main {
  padding: 24px;
  border-radius: 16px;
  outline: 1px rgba(0, 0, 0, 0.10) solid;
}

.AddButton {
  margin-top: 16px;
}
</style>